import VacancyProfileRouter from './VacancyProfile.router';

export default VacancyProfileRouter;
